import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import 'styles/index.css';
import 'styles/des.css';
import 'styles/color.css';
import 'styles/text.css';
import 'styles/header.css';
import 'styles/custom.css';
import 'styles/main.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
